import { Box, Button } from "@mui/material";
import { useEffect, useRef } from "react";
import { FlexCenterWrapper } from "../../../../../components/DefaultNoDataWrapper";
import StyledModal from "../../../../../components/globalModal/StyledModal";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import useTwilioCallController from "../../../../../hooks/useTwilioCallController";
import { useGetPatient } from "../../../../../queries/use-get-patient-uuid";
import Timer from "../../patient/patient-list/patient-chart-new/patient-visit-note/ai-scriber/Timer";
import { useTimer } from "../../patient/patient-list/patient-chart-new/patient-visit-note/ai-scriber/useTimer";
import { useQueryClient } from "@tanstack/react-query";

type ContactDialModalProps = {
  disclosureHost: DisclosureHost;
  contactNumber?: string;
  onSave?: () => void;
};

export const ContactDialModal = ({
  disclosureHost,
  contactNumber,
  onSave,
}: ContactDialModalProps) => {
  const rawData = disclosureHost.data;
  const patientId =
    typeof rawData === "string"
      ? rawData
      : (rawData?.uuid ?? rawData?.patientId);

  // Fall back to fetching the patient when the caller didn't pass a number.
  const { data: patient } = useGetPatient(
    patientId,
    !disclosureHost.opened || !!contactNumber
  );
  const dialNumber = contactNumber ?? patient?.mobileNumber;

  const { disconnectCall, quickConnect, callStatus } =
    useTwilioCallController(patientId);
  const { time, startTimer } = useTimer();

  useEffect(() => {
    callStatus === "connected" && startTimer();
  }, [callStatus]);

  const hasAttempted = useRef(false);
  const wasConnected = useRef(false);
  useEffect(() => {
    if (callStatus === "connecting" || callStatus === "connected") {
      hasAttempted.current = true;
    }
    if (callStatus === "connected") wasConnected.current = true;
  }, [callStatus]);

  useEffect(() => {
    if (dialNumber) quickConnect(dialNumber);
  }, [dialNumber]);

  const queryClient = useQueryClient();
  const invalidateGetAllCallsAndClose = () => {
    queryClient.invalidateQueries({ queryKey: ["twilio-recorded-audio"] });

    disclosureHost.close();
  };

  return (
    <StyledModal
      open={disclosureHost.opened}
      onClose={() => invalidateGetAllCallsAndClose()}
      dialogTitle="Contact Dial"
    >
      <Box width={"20vw"} height={"140px"}>
        <FlexCenterWrapper>
          {callStatus === "connecting" && "Connecting..."}
          {callStatus === "connected" && <Timer time={time} />}
          {!dialNumber && !hasAttempted.current && "No phone number available"}
          {callStatus === "disconnected" && "Disconnected"}
          <Button
            variant="contained"
            disabled={callStatus !== "connected"}
            color="error"
            onClick={() => {
              disconnectCall();
              setTimeout(() => {
                disclosureHost.close();
                onSave?.();
              }, 1000);
            }}
          >
            End Call
          </Button>
        </FlexCenterWrapper>
        {/* <DialPad
        value={phoneNumber}
        onChange={setPhoneNumber}
        onCall={connectToPhoneNumber}
        onHangup={disconnectCall}
        callStatus={callStatus}
        isCallButtonDisabled={false}
        myCall={call.current ?? undefined}
      /> */}
      </Box>
    </StyledModal>
  );
};
